import { addRoad, addSprite, lastY, Util } from './helper-functions';
import { ROAD, segmentLength } from './constants';
import { mapy } from './custom-lobby/mapy';

export type MapsTemp = 'bigApple' | 'stackPlaza' | 'degenRaceway' | 'miamiBeach';

export const carPropsFns: Record<MapsTemp, (segmentLength: any, step: any) => any> = {
  bigApple: (segmentLength: any, step: any) => {
    var maxSpeed = segmentLength / step; // top speed (ensure we can't move more than 1 segment in a single frame to make collision detection easier)
    var accel = maxSpeed / 3.5; // acceleration rate - tuned until it 'felt' right
    var breaking = -maxSpeed * 1.3; // deceleration rate when braking
    return { maxSpeed, accel, breaking };
  },
  stackPlaza: (segmentLength, step) => {
    var maxSpeed = segmentLength / step; // top speed (ensure we can't move more than 1 segment in a single frame to make collision detection easier)
    var accel = maxSpeed / 3.5; // acceleration rate - tuned until it 'felt' right
    var breaking = -maxSpeed * 1.3; // deceleration rate when braking
    return { maxSpeed, accel, breaking };
  },
  degenRaceway: (segmentLength, step) => {
    var maxSpeed = segmentLength / step; // top speed (ensure we can't move more than 1 segment in a single frame to make collision detection easier)
    var accel = maxSpeed / 4; // acceleration rate - tuned until it 'felt' right
    var breaking = -maxSpeed * 1.4; // deceleration rate when braking
    return { maxSpeed, accel, breaking };
  },
  miamiBeach: (segmentLength, step) => {
    var maxSpeed = segmentLength / step; // top speed (ensure we can't move more than 1 segment in a single frame to make collision detection easier)
    var accel = maxSpeed / 4; // acceleration rate - tuned until it 'felt' right
    var breaking = -maxSpeed * 1.5; // deceleration rate when braking
    return { maxSpeed, accel, breaking };
  },
};

export const resetSpritesFns: Record<MapsTemp, (SPRITES: any, segments: any) => void> = {
  stackPlaza: (SPRITES: any, segments) => {
    var n, i;

    addSprite(20, SPRITES.BILLBOARD05, 1, segments);
    addSprite(40, SPRITES.BILLBOARD04, 1, segments);
    addSprite(60, SPRITES.BILLBOARD06, 1, segments);
    addSprite(80, SPRITES.BILLBOARD01, 1, segments);
    addSprite(110, SPRITES.BILLBOARD08, 1, segments);
    addSprite(150, SPRITES.BILLBOARD09, 1, segments);

    addSprite(20, SPRITES.BILLBOARD05, -1, segments);
    addSprite(40, SPRITES.BILLBOARD04, -1, segments);
    addSprite(60, SPRITES.BILLBOARD06, -1, segments);
    addSprite(80, SPRITES.BILLBOARD01, -1, segments);
    addSprite(110, SPRITES.BILLBOARD08, -1, segments);
    addSprite(150, SPRITES.BILLBOARD09, -1, segments);

    addSprite(240, SPRITES.BILLBOARD07, -1.2, segments);
    addSprite(240, SPRITES.BILLBOARD06, 1.2, segments);
    addSprite(segments.length - 25, SPRITES.BILLBOARD07, -1.2, segments);
    addSprite(segments.length - 25, SPRITES.BILLBOARD06, 1.2, segments);

    for (n = 250; n < 2000 && n < segments.length; n += 15) {
      addSprite(n, SPRITES.COLUMN, 1.1, segments);
    }

    for (n = 250; n < 2000 && n < segments.length; n += 25) {
      addSprite(n, SPRITES.COLUMN, -1.1, segments);
    }

    var side, sprite, offset;
    var min = segments.length - 50;
    if (3250 < min) min = 5000;
    for (n = 2000; n < min; n += 100) {
      side = Util.randomChoice([1, -1]);
      addSprite(n + Util.randomInt(0, 50), Util.randomChoice(SPRITES.BILLBOARDS), -side, segments);
      for (i = 0; i < 20; i++) {
        sprite = Util.randomChoice(SPRITES.PLANTS);
        offset = side * (1.5 + Math.random());
        addSprite(n + Util.randomInt(0, 50), sprite, offset, segments);
      }
    }

    for (n = 3300; n < 5000 && n < segments.length; n += 20) {
      addSprite(n, SPRITES.COLUMN, 1.1, segments);
    }

    for (n = 3300; n < 5000 && n < segments.length; n += 17) {
      addSprite(n, SPRITES.COLUMN, -1.1, segments);
    }

    var side, sprite, offset;
    for (n = 5000; n < segments.length - 50; n += 100) {
      side = Util.randomChoice([1, -1]);
      addSprite(n + Util.randomInt(0, 50), Util.randomChoice(SPRITES.BILLBOARDS), -side, segments);
      for (i = 0; i < 20; i++) {
        sprite = Util.randomChoice(SPRITES.PLANTS);
        offset = side * (1.5 + Math.random());
        addSprite(n + Util.randomInt(0, 50), sprite, offset, segments);
      }
    }
  },
  bigApple: (SPRITES: any, segments) => {
    let n, i;
    addSprite(20, SPRITES.BILLBOARD07, -1, segments);
    addSprite(40, SPRITES.BILLBOARD06, -1, segments);
    addSprite(60, SPRITES.BILLBOARD09, -1, segments);
    addSprite(85, SPRITES.BILLBOARD05, -1, segments);
    addSprite(115, SPRITES.BILLBOARD08, -1, segments);
    addSprite(145, SPRITES.BILLBOARD01, -1, segments);
    addSprite(20, SPRITES.BILLBOARD07, 1, segments);
    addSprite(40, SPRITES.BILLBOARD06, 1, segments);
    addSprite(60, SPRITES.BILLBOARD09, 1, segments);
    addSprite(85, SPRITES.BILLBOARD05, 1, segments);
    addSprite(115, SPRITES.BILLBOARD08, 1, segments);
    addSprite(145, SPRITES.BILLBOARD01, 1, segments);
    addSprite(240, SPRITES.BILLBOARD06, -1.2, segments);
    addSprite(240, SPRITES.BILLBOARD06, 1.2, segments);
    addSprite(segments.length - 25, SPRITES.BILLBOARD07, -1.2, segments);
    addSprite(segments.length - 25, SPRITES.BILLBOARD06, 1.2, segments);
    for (n = 250; n < 1000 && n < segments.length; n += 5) {
      addSprite(n, SPRITES.COLUMN, 1.1, segments);
      addSprite(n, SPRITES.COLUMN, -1.1, segments);
    }
    for (n = 200; n < segments.length; n += 3) {
      addSprite(n, Util.randomChoice(SPRITES.PLANTS), Util.randomChoice([1, -1]) * (2 + Math.random() * 5), segments);
    }
    var side, sprite, offset;
    for (n = 1000; n < segments.length - 50; n += 120) {
      side = Util.randomChoice([1, -1]);
      addSprite(n + Util.randomInt(0, 50), Util.randomChoice(SPRITES.BILLBOARDS), -side, segments);
      for (i = 0; i < 20; i++) {
        sprite = Util.randomChoice(SPRITES.PLANTS);
        offset = side * (1.5 + Math.random());
        addSprite(n + Util.randomInt(0, 50), sprite, offset, segments);
      }
    }
  },
  degenRaceway: (SPRITES, segments) => {
    var n, i;

    addSprite(60, SPRITES.BILLBOARD01, 1, segments);

    addSprite(40, SPRITES.BILLBOARD04, 1, segments);
    addSprite(20, SPRITES.BILLBOARD05, 1, segments);

    addSprite(20, SPRITES.BILLBOARD07, -1, segments);
    addSprite(40, SPRITES.BILLBOARD06, -1, segments);
    addSprite(60, SPRITES.BILLBOARD08, -1, segments);
    addSprite(80, SPRITES.BILLBOARD09, -1, segments);
    addSprite(100, SPRITES.BILLBOARD01, -1, segments);
    addSprite(160, SPRITES.BILLBOARD04, -1, segments);
    addSprite(180, SPRITES.BILLBOARD05, -1, segments);

    addSprite(240, SPRITES.BILLBOARD07, -1.2, segments);
    addSprite(240, SPRITES.BILLBOARD06, 1.2, segments);
    addSprite(segments.length - 25, SPRITES.BILLBOARD07, -1.2, segments);
    addSprite(segments.length - 25, SPRITES.BILLBOARD06, 1.2, segments);

    for (n = 70; n < 200 && n < segments.length; n += 10 + Math.floor(n / 100)) {
      addSprite(n, SPRITES.TREE1, 0.5 + Math.random() * 0.5, segments);
      addSprite(n, SPRITES.TREE2, 1 + Math.random() * 2, segments);
    }

    for (n = 250; n < 1000 && n < segments.length; n += 5) {
      addSprite(n + Util.randomInt(0, 5), SPRITES.TREE1, -1 - Math.random() * 2, segments);
      addSprite(n + Util.randomInt(0, 5), SPRITES.TREE2, -1 - Math.random() * 2, segments);
      addSprite(n + Util.randomInt(0, 5), SPRITES.TREE1, -1 * (-1 - Math.random() * 2), segments);
      addSprite(n + Util.randomInt(0, 5), SPRITES.TREE2, -1 * (-1 - Math.random() * 2), segments);
    }

    for (n = 200; n < segments.length; n += 3) {
      addSprite(n, Util.randomChoice(SPRITES.PLANTS), Util.randomChoice([1, -1]) * (2 + Math.random() * 5), segments);
    }

    var side, sprite, offset;
    for (n = 500; n < segments.length - 50; n += 50) {
      side = Util.randomChoice([1, -1]);
      addSprite(n + Util.randomInt(0, 50), Util.randomChoice(SPRITES.BILLBOARDS), -side, segments);
      for (i = 0; i < 20; i++) {
        sprite = Util.randomChoice(SPRITES.PLANTS);
        offset = side * (1.5 + Math.random());
        addSprite(n + Util.randomInt(0, 50), sprite, offset, segments);
      }
    }
  },
  miamiBeach: (SPRITES, segments) => {
    var n, i;

    addSprite(20, SPRITES.BILLBOARD07, -1, segments);
    addSprite(60, SPRITES.BILLBOARD06, -1, segments);
    addSprite(90, SPRITES.BILLBOARD08, -1, segments);
    addSprite(120, SPRITES.BILLBOARD09, -1, segments);
    addSprite(150, SPRITES.BILLBOARD01, -1, segments);
    addSprite(180, SPRITES.BILLBOARD04, -1, segments);
    addSprite(210, SPRITES.BILLBOARD05, -1, segments);

    addSprite(20, SPRITES.BILLBOARD07, 1, segments);
    addSprite(60, SPRITES.BILLBOARD06, 1, segments);
    addSprite(90, SPRITES.BILLBOARD08, 1, segments);
    addSprite(120, SPRITES.BILLBOARD09, 1, segments);
    addSprite(150, SPRITES.BILLBOARD01, 1, segments);
    addSprite(180, SPRITES.BILLBOARD04, 1, segments);
    addSprite(210, SPRITES.BILLBOARD05, 1, segments);

    addSprite(240, SPRITES.BILLBOARD07, -1.2, segments);
    addSprite(240, SPRITES.BILLBOARD06, 1.2, segments);
    addSprite(segments.length - 25, SPRITES.BILLBOARD07, -1.2, segments);
    addSprite(segments.length - 25, SPRITES.BILLBOARD06, 1.2, segments);

    for (n = 250; n < 1000 && n < segments.length; n += 5) {
      addSprite(n, SPRITES.COLUMN, 1.1, segments);
      addSprite(n, SPRITES.COLUMN, -1.1, segments);
    }

    for (n = 200; n < segments.length; n += 3) {
      addSprite(n, Util.randomChoice(SPRITES.PLANTS), Util.randomChoice([1, -1]) * (2 + Math.random() * 5), segments);
    }

    var side, sprite, offset;
    for (n = 1000; n < segments.length - 50; n += 120) {
      side = Util.randomChoice([1, -1]);
      addSprite(n + Util.randomInt(0, 50), Util.randomChoice(SPRITES.BILLBOARDS), -side, segments);
      for (i = 0; i < 20; i++) {
        sprite = Util.randomChoice(SPRITES.PLANTS);
        offset = side * (1.5 + Math.random());
        addSprite(n + Util.randomInt(0, 50), sprite, offset, segments);
      }
    }
  },
};
export const addDownhillToEndFns: Record<MapsTemp, (colors: any, num: any, segments: any) => void> = {
  stackPlaza: (COLORS, num, segments) => {
    num = num || 200;
    addRoad(num, num, num, ROAD.CURVE.MEDIUM, -lastY(segments) / segmentLength, COLORS, segments);
  },
  bigApple: (COLORS, num, segments) => {
    num = num || 200;
    addRoad(num, num, num, -ROAD.CURVE.MEDIUM, -lastY(segments) / segmentLength, COLORS, segments);
  },
  degenRaceway: (COLORS, num, segments) => {
    num = num || 200;
    addRoad(num, num, num, ROAD.CURVE.HARD, -lastY(segments) / segmentLength, COLORS, segments);
  },
  miamiBeach: (COLORS, num, segments) => {
    num = num || 200;
    addRoad(num, num, num, ROAD.CURVE.HARD, -lastY(segments) / segmentLength, COLORS, segments);
  },
};

export interface ResetRoadArgs {
  addStraight: (val: number) => void;
  addCurve: (val1: number, val2: number, val3: number) => void;
  addBumps: () => void;
  addSCurves: () => void;
  addLowRollingHills: () => void;
  addHill: (val1: number, val2: number) => void;
  addDownhillToEnd: (colors: any, num: any, segments: any) => void;
  addGenRoad: (params: Array<number>, COLORS: any, segment: any) => void;
  resetSprites: (SPRITES: any, segments: any) => void;
  resetCars: () => void;

  segments: any[];
  COLORS: any;
  SPRITES: any;
  road: Array<number> | null;
}

export const resetRoadFns: Record<MapsTemp, (params: ResetRoadArgs) => void> = {
  bigApple: (params: ResetRoadArgs) => {
    const {
      addStraight,
      addCurve,
      addBumps,
      addSCurves,
      addLowRollingHills,
      addHill,
      addDownhillToEnd,
      addGenRoad,
      resetSprites,
      resetCars,
      segments,
      COLORS,
      SPRITES,
      road,
    } = params;

    if (road && road.length) {
      road.forEach((x) => {
        addGenRoad((mapy as any)[x], COLORS, segments);
      });
    } else {
      addStraight(ROAD.LENGTH.LONG);
      addCurve(ROAD.LENGTH.LONG, ROAD.CURVE.EASY, -ROAD.HILL.HIGH);
      addBumps();
      addSCurves();
      addLowRollingHills();
      addCurve(ROAD.LENGTH.SHORT, -1.2 * ROAD.CURVE.HARD, ROAD.HILL.HIGH);
      addHill(ROAD.LENGTH.MEDIUM, -1.3 * ROAD.HILL.HIGH);
      addBumps();
      addSCurves();
      addHill(ROAD.LENGTH.MEDIUM, -2 * ROAD.HILL.HIGH);
      addCurve(ROAD.LENGTH.SHORT, -ROAD.CURVE.MEDIUM, ROAD.HILL.HIGH);
      addCurve(ROAD.LENGTH.LONG, ROAD.CURVE.HARD, -1.5 * ROAD.HILL.HIGH);
      addHill(ROAD.LENGTH.MEDIUM, 1.3 * ROAD.HILL.HIGH);
      addSCurves();
      addHill(ROAD.LENGTH.MEDIUM, -2 * ROAD.HILL.HIGH);
      addHill(ROAD.LENGTH.SHORT, ROAD.HILL.HIGH);
      addSCurves();
      addCurve(ROAD.LENGTH.LONG, -1.2 * ROAD.CURVE.HARD, -1.5 * ROAD.HILL.HIGH);
      addCurve(ROAD.LENGTH.LONG, ROAD.CURVE.HARD, ROAD.HILL.HIGH);
      addCurve(ROAD.LENGTH.LONG, -1.2 * ROAD.CURVE.HARD, -1.5 * ROAD.HILL.HIGH);
      addLowRollingHills();
    }

    addDownhillToEnd(COLORS, 200, segments);
    resetSprites(SPRITES, segments);

    resetCars();
  },
  stackPlaza: (params) => {
    const {
      addStraight,
      addCurve,
      addBumps,
      addSCurves,
      addLowRollingHills,
      addHill,
      addDownhillToEnd,
      addGenRoad,
      resetSprites,
      resetCars,
      segments,
      COLORS,
      SPRITES,
      road,
    } = params;

    if (road && road.length) {
      road.forEach((x) => {
        addGenRoad((mapy as any)[x], COLORS, segments);
      });
    } else {
      // changed road - it displayed too much the terrain under the buildings
      addStraight(ROAD.LENGTH.LONG);
      addBumps();
      addBumps();
      addSCurves();
      addHill(ROAD.LENGTH.MEDIUM, 1.3 * ROAD.HILL.HIGH);
      addCurve(1.3 * ROAD.LENGTH.LONG, ROAD.CURVE.HARD, 2 * ROAD.HILL.HIGH);
      addSCurves();
      addSCurves();
      addBumps();
      addCurve(ROAD.LENGTH.LONG, 1 * ROAD.CURVE.HARD, ROAD.HILL.HIGH);
      addCurve(ROAD.LENGTH.SHORT, -1.2 * ROAD.CURVE.HARD, ROAD.HILL.HIGH);
      addLowRollingHills();
      addHill(ROAD.LENGTH.MEDIUM, 1.3 * ROAD.HILL.HIGH);
      addCurve(ROAD.LENGTH.LONG, 1.2 * ROAD.CURVE.MEDIUM, ROAD.HILL.HIGH);
    }

    addDownhillToEnd(COLORS, 200, segments);
    resetSprites(SPRITES, segments);

    resetCars();
  },
  degenRaceway: (params) => {
    const {
      addStraight,
      addCurve,
      addBumps,
      addSCurves,
      addLowRollingHills,
      addHill,
      addDownhillToEnd,
      addGenRoad,
      resetSprites,
      resetCars,
      segments,
      COLORS,
      SPRITES,
      road,
    } = params;

    if (road && road.length) {
      road.forEach((x) => {
        addGenRoad((mapy as any)[x], COLORS, segments);
      });
    } else {
      addStraight(ROAD.LENGTH.MEDIUM);
      addHill(ROAD.LENGTH.MEDIUM, -1.7 * ROAD.HILL.HIGH);
      addCurve(ROAD.LENGTH.LONG, -1.1 * ROAD.CURVE.HARD, -2 * ROAD.HILL.HIGH);
      addSCurves();
      addSCurves();
      addLowRollingHills();
      addSCurves();
      addHill(ROAD.LENGTH.MEDIUM, 1.7 * ROAD.HILL.HIGH);
      addStraight(0.5 * ROAD.LENGTH.SHORT);
      addCurve(ROAD.LENGTH.MEDIUM, 1.2 * ROAD.CURVE.HARD, ROAD.HILL.HIGH);
      addHill(ROAD.LENGTH.MEDIUM, -2 * ROAD.HILL.HIGH);
      addCurve(ROAD.LENGTH.LONG, -ROAD.CURVE.HARD, -1.5 * ROAD.HILL.HIGH);
      addCurve(ROAD.LENGTH.SHORT, ROAD.CURVE.MEDIUM, ROAD.HILL.HIGH);
      addHill(ROAD.LENGTH.MEDIUM, 1.7 * ROAD.HILL.HIGH);
      addSCurves();
      addCurve(ROAD.LENGTH.LONG, 1.2 * ROAD.CURVE.HARD, -1.5 * ROAD.HILL.HIGH);
      addLowRollingHills();
    }

    addDownhillToEnd(COLORS, 200, segments);
    resetSprites(SPRITES, segments);

    resetCars();
  },
  miamiBeach: (params) => {
    const {
      addStraight,
      addCurve,
      addBumps,
      addSCurves,
      addLowRollingHills,
      addHill,
      addDownhillToEnd,
      addGenRoad,
      resetSprites,
      resetCars,
      segments,
      COLORS,
      SPRITES,
      road,
    } = params;

    if (road && road.length) {
      road.forEach((x) => {
        addGenRoad((mapy as any)[x], COLORS, segments);
      });
    } else {
      addStraight(ROAD.LENGTH.LONG);
      addBumps();
      addSCurves();
      addCurve(ROAD.LENGTH.LONG, -1.2 * ROAD.CURVE.HARD, -2 * ROAD.HILL.HIGH);
      addBumps();
      addLowRollingHills();
      addHill(ROAD.LENGTH.MEDIUM, -2 * ROAD.HILL.HIGH);
      addCurve(ROAD.LENGTH.SHORT, -ROAD.CURVE.MEDIUM, ROAD.HILL.HIGH);
      addSCurves();
      addHill(ROAD.LENGTH.MEDIUM, 1.3 * ROAD.HILL.HIGH);
      addBumps();
      addCurve(ROAD.LENGTH.LONG, 1.2 * ROAD.CURVE.HARD, ROAD.HILL.HIGH);
      addBumps();
      addCurve(ROAD.LENGTH.LONG, -1.2 * ROAD.CURVE.HARD, -1.5 * ROAD.HILL.HIGH);
      addBumps();
      addCurve(ROAD.LENGTH.LONG, -1.2 * ROAD.CURVE.HARD, -1.5 * ROAD.HILL.HIGH);
      addLowRollingHills();
      addSCurves();
    }

    addDownhillToEnd(COLORS, 200, segments);
    resetSprites(SPRITES, segments);

    resetCars();
  },
};
